<template>
  <div class="card shadow" v-for="submenu in submenus">
    <div class="card-body  p-sm-0">
      <h4 class="card-title mb-0">{{ submenu.name }}</h4>
      <hr>
    </div>
    <div class="card-body card-pd py-0">
      <div class="row text-center dashboard-card" style="margin: 5px auto;">
        <template v-for="(page, index) in submenu.pages" :key="getStatItem(page.route)">
          <component
            v-if="page.status === 'active' && statisticsItem[getStatItem(page.route)]"
            :is="cards[statisticsItem[getStatItem(page.route)].type]"
            :page="page"
            :itemKey="getStatItem(page.route)"
            :statisticsItem="statisticsItem"
            @onDateChange="onDateChange"
            @onTypeChange="onTypeChange"
            :timeRange="timeRange"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>


import {useRoute} from "vue-router";
import {onMounted, ref} from "vue";
import {useCardStatistics} from "@/services/modules/dashboard/cardStatistics";
import {
  CardTotalType,
  CardBarChart,
  CardPieChart,
  CardSummary,
  CardHosTotal,
  CardHosSummary,
  CardHosBarChart,
  AttendanceList,
  Attendance
} from '@/components/molecule/company/dashboard/dynamic-dashboard/components';

const cards = {
  'card_total_value': CardTotalType,
  'card_bar_chart': CardBarChart,
  'card_pie_chart': CardPieChart,
  'card_summary': CardSummary,
  'card_hos_total': CardHosTotal,
  'card_hos_summary': CardHosSummary,
  'card_hos_bar_chart': CardHosBarChart,
  'card_attendance_list': AttendanceList,
  'card_attendance': Attendance,
};

defineProps({
  submenus: Array,
})

onMounted(() => {
  getDashboardData()
})

const getStatItem = (routeKey) => {
  return routeKey.replace(/-/g, '_')
}

const route = useRoute()
const params = route.params
const filterQuery = ref({});

const onDateChange = (item) => {
  filterQuery.value[`${item.key}_date`] = JSON.stringify(item.date_range);

  const query = new URLSearchParams(filterQuery.value).toString();

  getDashboardData(`&${query}`)
}

const onTypeChange = (type) => {
  const query = `&type=${type}`;
  getDashboardData(query);
};

defineExpose({
  onDateChange,
  onTypeChange
});

const {
  timeRange,
  getDashboardData,
  statisticsItem
} = useCardStatistics(params)
</script>

<style scoped>

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 0 solid rgba(34, 41, 47, 0.125);
  border-radius: 15px;
}

.card-body {
  /*padding: 0;*/
  border-radius: 15px 15px 0 0 !important;
}

.card-title {
  background-color: #fff;
  margin: 0;
  padding: 15px 15px;
  color: #7D7D7D;
  border-radius: 15px 15px 0 0;
  /* border-bottom: .5px solid #7D7D7D; */
}

.card-pd {
  padding-left: 5px;
  padding-right: 5px;
}

.pd-5 {
  padding: 5px;
}

hr {
  margin: 0;
}

/deep/ .dashboard-card .card, /deep/ .dashboard-card .form-control {
  background-color: #ebecf0;
}

/deep/ .dashboard-card .card.height-235 {
  height: 235px;
}

/deep/ .dashboard-card .card .cut-text {
  width: 143px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
